export default __webpack_public_path__ + "static/media/illust_handle_light.bd45b05f.svg";